import { FcmAccountsLoaded } from "./fcmAccounts.actions";
import FcmAccount from "./fcmAccount";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";

export class FcmAccountsReducer extends ReducerBase<FcmAccount[]> {
    constructor() {
        super();
        this.addHandler(FcmAccountsLoaded.EventName, this.handleFcmAccountsLoaded);
    }

    handleFcmAccountsLoaded(
        state: FcmAccount[] = initialState.fcmAccounts
        , event: FcmAccountsLoaded): FcmAccount[] {
        return event.fcmAccounts;
    }

    handleDefault(state: FcmAccount[] = initialState.fcmAccounts) {
        return state;
    }
}
